import { CountCellProps } from '../../types';
import { formatNumberWithComma } from 'utils';

const TotalAvailableForImportsCountsCell = ({ _customRowProps, data }: CountCellProps) => {
  return <div>{formatNumberWithComma(+data.total)}</div>;
};

export default TotalAvailableForImportsCountsCell;
